import { useState, useEffect, useRef, useCallback } from 'react';

export function useTimer(duration: number, onExpire: () => void) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const intervalRef = useRef<number | null>(null);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  const start = useCallback(() => {
    setTimeLeft(duration);
    intervalRef.current = window.setInterval(() => {
      setTimeLeft((prev) => {
        const next = Math.max(0, prev - 0.1);
        if (next <= 0) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          setTimeout(() => onExpireRef.current(), 0);
        }
        return next;
      });
    }, 100);
  }, [duration]);

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    return () => stop();
  }, [stop]);

  return { timeLeft, start, stop };
}
